import React from 'react'
import ApiKeyComponent from './child/ApiKeyComponent'
import { motion } from 'framer-motion'


const ApiGatewayLayer = () => {
    return (
        <motion.div 
        initial={{
            opacity: 0
        }}
        animate={{
            opacity: 1
        }}
        transition={{
            duration: 1
        }}
        className="card h-100 p-0 radius-12">
            <div className="card-body p-24">
                <div className="row gy-4">
                    <ApiKeyComponent/>
                </div>
            </div>
        </motion.div>

    )
}

export default ApiGatewayLayer